import { debug } from 'zf-web-infra';
import { convert } from '../../icons';
import type { DataNode } from 'antd/es/tree';
import type { DataSource, TreeKeys } from '../types';

export class TreeService {

  findExpandedByText(data: DataSource, text: string): TreeKeys {
    return data
      .filter(item => item.name.includes(text))
      .map(item => item._id);
  }

  /**
   * 获取第一层节点的 _id
   * @param source
   * @param rootId 根节点的 id (现在后台默认是 all)
   */
  getRootNodes(source: DataSource, rootId = 'all'): TreeKeys {
    // item.parent === rootId 改成了 item._id === rootId 否则第一层节点都会被展开而不是展开根节点
    return source.filter(item => item.parent == null || item.parent === '' || item._id === rootId)
      .map(item => item._id);
  }

  getDefaultExpandedKeys(source: DataSource, expendRoot = true, expandedKeys: TreeKeys = []): TreeKeys {
    if (expendRoot) {
      return this.getRootNodes(source).concat(expandedKeys);
    }
    return expandedKeys;
  }

  /**
   * 列表结构数据转换为树结构数据，为提高效率不使用递归
   * @param source
   * @param isLockRoot
   * @returns
   */
  toTree(source: DataSource, isLockRoot = false): DataNode[] {
    debug.common('toTree');

    const hash = Object.create(null);
    source.forEach(item => {
      hash[item._id as string] = {
        key: item._id,
        title: item?.title ?? item.name,
        value: item._id,
        icon: convert(item.icon),
        parent: item.parent,
        groupType: item.groupType,
        children: [],
        disabled: isLockRoot ? (item.parent === '' && item.idPath?.length === 1) : false
      };
    });

    const result: DataNode[] = [];
    source.forEach(item => {
      // React.Key 包含 bigint 类型，直接用于索引会有类型错误，这里强制视为 string 处理
      const id = item._id as string;
      const parent = item.parent as string;

      if (parent != null && parent !== '') {
        // 防止无父节点数据导致树渲染异常
        if (hash[parent] == null) {
          return;
        }
        return hash[parent].children.push(hash[id]);
      }

      result.push(hash[id]);
    });

    debug.common('tree', result);
    return result;
  }

}
